import {
    Container,
    Divider,
    Stack
} from '@mui/material';
import React from 'react';
import { Page } from '../../../../components';
import HeaderBreadcrumbs from '../../../../components/header-breadcrumbs';
import {Outlet} from "react-router-dom";

export const ReportListScreen: React.FC = () => {
    const [reportTitle, setReportTitle] = React.useState<string>("Reports");
    const [reportDescText, setReportDescText] = React.useState<string>("Easily generate the insights you need. Choose from safety, risk, or review reports to stay informed and make data-driven decisions. Select an option below to begin creating your custom report.");

    return (
        <>
            <Page title="POM Admin - Reports">
                <Container maxWidth={false}>
                    {reportTitle && (
                        <>
                            <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <HeaderBreadcrumbs
                                    heading={reportTitle}
                                    links={[
                                        {
                                            name: reportDescText,
                                            href: '/reports',
                                        },
                                    ]}
                                    activeLast={false}
                                />
                            </Stack>
                            <Divider sx={{ mt: 3}} />
                        </>
                    )}
                    <Outlet context={{
                        setReportTitle,
                        setReportDescText
                    }}
                    />
                </Container>
            </Page>
        </>
    );
};
